<template>
    <div id="transaction-history">
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Transaction History') }}</h3>
                <span class="fz-16 fw-400">{{ $t('View your transaction history here') }}</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <b-row class="pt-3">
                <b-col cols="12">

                    <div class="block-item p-3 w-100 mb-4"
                        style="margin-top:-100px;box-shadow: 0px 5px 10px 0px #0000000D;">
                        <b-row class="align-items-end">

                            <b-col cols="12" md="3" class="h-100">
                                <label class="mb-0">Transaction Type :</label>
                                <select class="form-control" v-model="search.type">
                                    <option value="" selected>-- All --</option>
                                    <option value="Topup">Topup</option>
                                    <option value="Refund">Refund</option>
                                    <option value="Transfer">Transfer</option>
                                    <option value="Withdrawal">Withdrawal</option>
                                    <option value="Remittance">Remittance</option>
                                    <option value="Withdrawal Fee">Withdrawal Fee</option>
                                    <option value="Remittance Fee">Remittance Fee</option>
                                </select>
                            </b-col>

                            <b-col cols="12" md="3" class="h-100 d-flex flex-column justify-content-end">
                                <label class="mb-0">{{$t('Date Range')}} :</label>
                                <date-range-picker
                                    ref="historyRange"
                                    v-model="dateRange"
                                    :locale="dtFormat"
                                    :time-picker="false"
                                    :time-picker24-hour="false"
                                    style="width:100%"
                                >
                                    <template #input="picker">
                                        <div
                                            style="min-width:100px; height:38px; display:flex; align-items:center; padding:0 12px; cursor:pointer;"
                                        >
                                            {{ dateRange.startDate && dateRange.endDate ? `${dateRange.startDate} - ${dateRange.endDate}` : '--All--' }}
                                        </div>
                                    </template>
                                </date-range-picker>
                            </b-col>

                            <b-col cols="12" md="2" class="h-100">
                                <label class="mb-0">Currency :</label>
                                <select class="form-control" v-model="search.currency">
                                    <option value="" selected>-- All --</option>
                                    <option :value="item" v-for="item in currencyList" :key="item">{{ item }}</option>
                                </select>
                            </b-col>

                            <b-col cols="12" md="2" class="h-100">
                                <label class="mb-0">Order No :</label>
                                <input type="text" class="form-control" placeholder="-- All --"
                                    v-model="search.order" />
                            </b-col>

                            <b-col cols="12" md="2" class="h-100">
                                <button class="btn btn-primary w-100 mt-3" @click="doFilter">Search</button>
                            </b-col>
                        </b-row>
                    </div>

                    <div id="body-container" class="w-100 mb-4 mt-0">

                        <div class="overflow-auto">
                            <table ref="myTable" class="table table-bordered position-relative" width="100%">
                                <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="7">
                                            <div class="dot-loading mt-3">
                                                <ul class="loader-circle">
                                                    <li></li>
                                                    <li></li>
                                                    <li></li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>

</template>

<script>
import CreateAccount from '@/services/CreateAccount';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-responsive';

import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

const baseURL = (process.env.VUE_APP_ENVIRONMENT == "production") ?
    "https://gep-api.cgtechnology.io" : (process.env.VUE_APP_ENVIRONMENT == "development" ?
        "https://gep-api.cgtechnology.io" : "https://gep-api.cgtechnology.io");
const token = localStorage.getItem('token');

const STATUS = {
    1: "Processing",
    2: "Approved",
    3: "Rejected"
};

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
            search: {
                date_start: '',
                date_end: '',
                currency: '',
                type: '',
                order: ''
            },
            transactions: [],
            isLoading: false,
            currencyList: [],
            dataTable: null,
            dateRange: {
                startDate: '',
                endDate: ''
            },
            dtFormat: {
                format: 'DD-MMM-YYYY', // Format tampilan picker
                separator: ' - ',      // Separator
                applyLabel: 'Apply',   // Tombol apply
                cancelLabel: 'Cancel', // Tombol cancel
                weekLabel: 'W',        // Label minggu
                customRangeLabel: 'Custom Range', // Label custom range
                daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // Nama hari
                monthNames: [
                    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                ], // Nama bulan
                firstDay: 0 // Minggu sebagai hari pertama
            }
        }
    },
    filters: {
        // Filter untuk memformat tanggal ke DD-MMM-YYYY
        date(value) {
            if (!value) return '';
            return moment(value, 'YYYY-MM-DD').format('DD-MMM-YYYY'); // Format ke DD-MMM-YYYY
        }
    },
    props: ['userNo'],
    components: {
        DateRangePicker
    },
    methods: {
        doFilter() {
            // Ambil tanggal dari dateRange ke search
            this.search.date_start = this.dateRange.startDate;
            this.search.date_end = this.dateRange.endDate;

            let filteredData = this.transactions;

            if (this.search.type) {
                filteredData = filteredData.filter(item => item.type === this.search.type);
            }

            // Filter tanggal di array, bukan hanya di DataTable
            if (this.search.date_start && this.search.date_end) {
                filteredData = filteredData.filter(item => {
                    const date = moment(item.createdAt || item.created_at, 'YYYY-MM-DD');
                    const start = moment(this.search.date_start, 'YYYY-MM-DD');
                    const end = moment(this.search.date_end, 'YYYY-MM-DD');
                    return date.isBetween(start, end, undefined, '[]');
                });
            }

            if (this.search.currency) {
                filteredData = filteredData.filter(item => item.ccy === this.search.currency);
            }

            if (this.search.order) {
                filteredData = filteredData.filter(item => item.orderId.includes(this.search.order));
            }

            this.updateDataTable(filteredData);
        },
        updateDataTable(filteredData) {
            this.dataTable.clear();
            this.dataTable.rows.add(filteredData).draw();
        },

        checkError(err) {
            const response = err.response;
            try {
                if (response.status == 401 && response.data.name == "Unauthorized") {
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({
                        path: '/login',
                    });
                }
                else {
                    if (localStorage.getItem("token")) {
                        var msg = (response.data) ? response.data.message : err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            } catch (e) {
                console.log(err);
            }
        }
    },
    mounted() {
        let self = this;
        this.$nextTick(() => {

            self.isLoading = true;

            this.dataTable = $(this.$refs.myTable).DataTable({
                dom: 'lBfrpit',
                "bLengthChange": false,
                "bInfo": true,
                order: [
                    [9, 'desc']
                ],
                data: self.transactions,
                buttons: [
                    {
                        extend: 'copy',
                        text: '<div class="d-flex align-items-center"><i class="fa-regular fa-copy"></i> <span class="mx-auto">Copy</span></div>',
                        titleAttr: 'CSV'
                    }, {
                        extend: 'csv',
                        text: '<div class="d-flex align-items-center"><i class="fa-solid fa-file-csv"></i> <span class="mx-auto">Download</span></div>',
                        titleAttr: 'CSV'
                    }, {
                        extend: 'print',
                        text: '<div class="d-flex align-items-center"><i class="fa-solid fa-print"></i> <span class="mx-auto">Print</span></div>',
                        titleAttr: 'Print'
                    }],
                searching: false,
                pagingType: "simple",
                language: {
                    info: '_START_-_END_ of _TOTAL_',
                    search: '<i class="fa fa-search"></i>',
                    searchPlaceholder: "search",
                    paginate: {
                        next: '<i class="fas fa-chevron-right"></i>',
                        previous: '<i class="fas fa-chevron-left"></i>',
                    },
                },
                display: 'stripe',
                paging: true,
                columns: [
                    { data: "bankAccountName", title: "Bank Account Name" },
                    { data: "accountName", title: "Account Name" },
                    { data: "orderId", title: "Order No." },
                    { data: "ccy", title: "Currency" },
                    { data: "type", title: "Transaction Type" },
                    { data: "in", title: "In/Reload" },
                    { data: "out", title: "Out" },
                    { data: "balance", title: "Balance" },
                    { data: "status", title: "Transaction Status" },
                    { data: "createdAt", title: "Date" }
                ]
            });

            CreateAccount.TransactionList().then((response) => {
                if (response.status == 200) {

                    self.isLoading = false;
                    const responseData = response.data;
                    self.transactions = responseData.data;

                    let arr_in = ['topup', 'refund'];
                    let balance = 0;

                    self.transactions.forEach(function (item) {
                        if (arr_in.includes(item.type)) {
                            item['in'] = parseFloat(item.amount).toFixed(2);
                            item['out'] = "-";
                            balance += parseFloat(item.amount);
                        }
                        else {
                            item['in'] = "-";
                            item['out'] = parseFloat(item.amount).toFixed(2);
                            balance -= parseFloat(item.amount);
                        }

                        if (item.ccy && (self.currencyList.length == 0 || !self.currencyList.includes(item.ccy))) {
                            self.currencyList.push(item.ccy);
                        }

                        let type = item.type.split("_");
                        type.forEach(function (tmp, index) {
                            type[index] = String(tmp).charAt(0).toUpperCase() + String(tmp).slice(1);
                        });

                        item['type'] = type.join(" ");
                        item['balance'] = balance.toFixed(2);
                    });

                    self.transactions.sort((a, b) => {
                        return moment(b.createdAt).unix() - moment(a.createdAt).unix();
                    });

                    self.doFilter();
                }
            })
                .catch((err) => {
                    self.checkError(err);
                });

        });
    },
    destroyed() {
        if (this.dataTable !== null) {
            this.dataTable.destroy(true);
        }
    }
};
</script>

<style>
@import url("https://cdn.datatables.net/2.1.5/css/dataTables.dataTables.min.css");

.dataTables_length {
    float: left;
}

div.dataTables_wrapper div.dataTables_filter {
    position: relative;
    /* margin-top: 10px; */
}

div.dataTables_filter label {
    margin: 0;
}

div.dataTables_filter svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    color: #899197;
}

div.dataTables_wrapper div.dataTables_filter input {
    padding-left: 35px;
    border: 1px solid #D1D4D7 !important;
    font-size: 16px !important;
}

div.dataTables_info {
    float: right;
    margin-top: 15px;
    margin-right: 5px;
    color: #899197;
    font-weight: 400;
    font-size: 14px;
}

div.dataTables_paginate.paging_simple {
    float: right;
}

div.dataTables_paginate.paging_simple ul.pagination {
    margin-top: 15px !important;
    margin-bottom: 12px !important;
}

div.dataTables_paginate.paging_simple ul.pagination li {
    background: unset !important;
}

div.dataTables_paginate.paging_simple ul.pagination li a {
    color: #2D3135 !important;
    padding: 12px 0px;
    width: 24px;
}

.dt-buttons {
    margin-bottom: 10px;
}

.dt-buttons button {
    background-color: unset !important;
    color: #2D3135;
    border: 1px solid #D1D4D7 !important;
    font-size: 14px;
    font-weight: 400;
    width: 100px;
}

#transaction-history input,
#transaction-history select,
#transaction-history textarea,
#transaction-history .input-group-text,
#transaction-history .form-control,
#transaction-history .input-group-alternative,
#transaction-history .input-group.input-no-border {
    font-size: 14px !important;
}

</style>